export function RightOutIcon() {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.168 7.84L3.928 4.192L0.168 0.544H2.312L6.056 4.192L2.312 7.84H0.168Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function FollowingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect width="16" height="16" fill="url(#pattern03)" />
      <defs>
        <pattern
          id="pattern03"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8065_8632" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_8065_8632"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
}
export function StarIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.836 17.8594L5.83604 20.1563C5.55948 20.2594 5.26886 20.0485 5.28292 19.7532L5.61104 13.336C5.61573 13.2376 5.58292 13.1391 5.52198 13.0594L1.48135 8.06255C1.29385 7.83286 1.40635 7.49067 1.69229 7.41099L7.89854 5.74224C7.99698 5.71411 8.08136 5.65317 8.13292 5.5688L11.6392 0.187549C11.7985 -0.0608887 12.1642 -0.0608887 12.3235 0.187549L15.8298 5.57349C15.886 5.65786 15.9704 5.7188 16.0642 5.74692L22.2704 7.41567C22.5564 7.49067 22.6689 7.83755 22.4814 8.06724L18.4454 13.0641C18.3845 13.1438 18.3517 13.2422 18.3564 13.3407L18.6845 19.7579C18.6985 20.0532 18.4079 20.2641 18.1314 20.161L12.1314 17.8641C12.0329 17.8266 11.9298 17.8266 11.836 17.8594Z"
        fill="#FFB636"
      />
      <path
        d="M21.3797 2.4234L19.4579 0.501521C19.4016 0.445271 19.3266 0.421833 19.2516 0.431208C19.1766 0.440583 19.1063 0.487458 19.0688 0.553083L17.086 4.45777C17.0297 4.55621 17.0485 4.6734 17.1282 4.75308C17.1751 4.79996 17.2407 4.8234 17.3016 4.8234C17.3438 4.8234 17.386 4.81402 17.4235 4.79058L21.3235 2.81246C21.3891 2.77496 21.436 2.70933 21.4454 2.62965C21.4594 2.55465 21.4313 2.47965 21.3797 2.4234ZM6.98912 4.46246L5.00631 0.557771C4.96881 0.492146 4.90318 0.445271 4.82349 0.435896C4.74849 0.426521 4.66881 0.449958 4.61724 0.506208L2.69537 2.42808C2.63912 2.48433 2.61568 2.55933 2.62506 2.63433C2.63443 2.70933 2.68131 2.77965 2.74693 2.81715L6.65162 4.79996C6.68912 4.8234 6.73131 4.83277 6.77349 4.83277C6.83912 4.83277 6.90006 4.80933 6.94693 4.76246C7.02662 4.67808 7.04068 4.55621 6.98912 4.46246V4.46246ZM13.5844 23.6812L12.2251 19.5187C12.2157 19.4765 12.1922 19.439 12.1641 19.4109C12.1172 19.364 12.0563 19.3406 11.9907 19.3406C11.8782 19.3406 11.7844 19.4156 11.7516 19.5234L10.3922 23.6859C10.3735 23.7609 10.3876 23.8406 10.4344 23.9015C10.4813 23.9625 10.5516 24 10.6313 24H13.3454C13.4204 24 13.4954 23.9625 13.5422 23.9015C13.5938 23.8359 13.6079 23.7562 13.5844 23.6812V23.6812Z"
        fill="#FFD469"
      />
    </svg>
  )
}
export function GiftIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9624 11.3625V23.25C11.9624 23.25 16.8749 19.8 20.3249 18.7875C20.3249 18.7875 20.4749 11.4375 22.6124 7.76245L11.9624 11.3625Z"
        fill="#076170"
      />
      <path
        d="M15.0376 21.45C15.0376 21.45 15.2251 10.9125 15.6001 10.3875C15.9751 9.82495 19.2001 9.26245 19.2001 9.26245C19.2001 9.26245 17.8876 19.125 18.1876 19.7625C18.2251 19.725 16.8751 20.2875 15.0376 21.45Z"
        fill="#B3690E"
      />
      <path
        d="M11.9623 23.25C11.9623 23.25 8.5123 20.325 3.1498 18.7875C3.1498 18.7875 3.5623 12.75 1.6123 8.13745L11.9623 11.3625V23.25Z"
        fill="#3BAACF"
      />
      <path
        d="M5.3248 19.7625C5.3248 19.7625 8.4748 21.0375 8.6998 21.45C8.9248 21.8625 8.9248 10.8375 8.9248 10.8375C8.9248 10.8375 4.6123 9.63745 4.2373 9.63745C4.2373 9.63745 5.5498 14.1 5.3248 19.7625Z"
        fill="#E9C243"
      />
      <path
        opacity="0.3"
        d="M11.9627 11.3625V13.35L21.6002 10.05C21.8627 9.22495 22.2002 8.43745 22.5752 7.76245L11.9627 11.3625ZM2.2877 10.2C2.1002 9.48745 1.8752 8.81245 1.5752 8.13745L11.9252 11.3625V13.35L2.2877 10.2Z"
        fill="black"
      />
      <path
        d="M0.75 7.08752L11.4375 9.45002L23.25 6.60002L11.6625 5.96252L0.75 7.08752Z"
        fill="#4FC7E8"
      />
      <path
        d="M0.75 7.08752L1.6125 9.45003L11.4375 12.225V9.45003L0.75 7.08752Z"
        fill="#3BAACF"
      />
      <path
        d="M11.4375 12.225C11.4375 12.225 20.3625 8.92495 22.575 8.77495C22.575 8.77495 22.725 7.46245 23.25 6.63745L11.4375 9.44995V12.225Z"
        fill="#076170"
      />
      <path
        d="M3.9375 7.7999L6.1125 9.8624L8.5125 8.7749L12 7.7249L16.35 8.2499L18.6375 8.6999L20.475 7.2749L3.9375 7.7999Z"
        fill="#F0AE11"
      />
      <path
        d="M8.5125 8.77495L12 7.72495L16.35 8.24995L20.475 7.27495L11.775 6.44995L3.9375 7.79995L8.5125 8.77495Z"
        fill="#F0AE11"
      />
      <path
        d="M3.9375 7.80005V10.425L8.325 11.625L8.5125 8.77505L3.9375 7.80005Z"
        fill="#F8D048"
      />
      <path
        d="M16.3501 8.25002L16.4251 10.7625L20.1751 9.63752L20.4751 7.27502L16.3501 8.25002Z"
        fill="#C47116"
      />
      <path
        d="M13.9875 6.4875C13.9875 6.4875 13.9875 3.8625 16.5375 1.575C16.5375 1.575 15 2.1375 14.25 1.9875C13.35 1.8375 13.05 0.75 13.05 0.75C13.05 0.75 10.875 5.475 11.5125 6.075C12.15 6.7125 13.9875 6.4875 13.9875 6.4875Z"
        fill="#EA9F07"
      />
      <path
        d="M10.6502 8.02502C10.6502 8.02502 9.1877 5.02502 6.0752 3.45002C6.0752 3.45002 8.5127 3.22502 9.0752 2.92502C9.7877 2.58752 10.2002 1.65002 10.2002 1.65002C10.2002 1.65002 12.9002 6.37502 12.6752 7.08752C12.4502 7.80002 10.6502 8.02502 10.6502 8.02502Z"
        fill="#F8D048"
      />
      <path
        d="M12.225 7.68752C12.225 7.68752 9.93746 8.58752 7.01246 8.58752C0.862461 8.55002 -3.98159e-05 4.12502 6.07496 4.53752C11.0625 4.91252 12.225 7.68752 12.225 7.68752Z"
        fill="#EA9F07"
      />
      <path
        d="M11.8123 7.64998C11.8123 7.64998 14.5123 7.87498 17.0248 7.23748C22.2748 5.88748 20.3248 1.91248 15.3748 3.59998C11.3248 4.98748 11.8123 7.64998 11.8123 7.64998Z"
        fill="#F0AE11"
      />
      <path
        d="M12.2248 7.68749C12.2248 7.68749 10.7998 8.24999 8.96229 8.24999C5.13729 8.24999 4.57479 5.47499 8.36229 5.73749C11.4748 5.96249 12.2248 7.68749 12.2248 7.68749Z"
        fill="#824000"
      />
      <path
        d="M12.2248 7.68751C12.2248 7.68751 14.0998 7.83751 15.8623 7.38751C19.5373 6.45001 18.1498 3.67501 14.7373 4.83751C11.8873 5.81251 12.2248 7.68751 12.2248 7.68751Z"
        fill="#824000"
      />
    </svg>
  )
}
